<template>
  <div>
    <!-- <div
      class="mb-10 transition-all duration-500 ease-in-out"
      :class="{
        'opacity-0': !Object.keys(usage).length,
        'opacity-1': Object.keys(usage).length > 0,
      }"
    >
      <div
        class="w-full flex bg-blueDianne/20 rounded border border-blueDianne/20"
      >
        <div
          class="bg-blueDianne h-[5px] rounded transition-all duration-500 ease-in-out"
          :style="`width: ${((usage.allowedChats - usage.remainingChats) / usage.allowedChats) * 100}%`"
        ></div>
      </div>
      <div class="inline text-blueDianne text-xs font-bold uppercase px-1">
        <context-popper :text="remainingChatText"
          ><span
            ><span class="uppercase text-puertoRico"
              >{{ usage.remainingChats }} chat<span
                v-if="usage.remainingChats != 1"
                >s</span
              >
              remaining</span
            >
            &nbsp;<i class="fa-solid fa-circle-info"></i
          ></span>
        </context-popper>
      </div>
    </div> -->
    <div
      v-if="
        Object.keys(previousResearchCompassItemsFromDatabaseByDate).length > 0
      "
    >
      <div
        v-for="(items, date) in previousResearchCompassItemsFromDatabaseByDate"
        :key="date"
      >
        <span class="text-tiara-500 uppercase text-xs font-bold">{{
          date
        }}</span>
        <ul class="text-sm">
          <li>
            <ul>
              <li
                v-for="item in items"
                :key="item.hashedId"
                class="pl-2 border-l border-tiara-300 dark:border-tiara-500"
                :class="{
                  'border-l-2 border-tiara-500 dark:border-tiara-300 font-bold':
                    item.hashedId == $route.params.researchCompassId,
                }"
              >
                <div class="flex w-full justify-between">
                  <router-link
                    class="text-blueDianne dark:text-white hover:underline"
                    :to="`/mine/${item.hashedId}`"
                    @click="$emit('toggle-history-tray')"
                    >{{ item.title }}</router-link
                  >
                  <button
                    class="text-tiara-300 hover:text-puertoRico text-xs ml-2"
                    @click="deleteResearchCompass(item.hashedId)"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-if="
        Object.keys(previousResearchCompassItemsFromCookiesByDate).length > 0
      "
    >
      <div
        v-for="(items, date) in previousResearchCompassItemsFromCookiesByDate"
        :key="date"
      >
        <span class="text-tiara-500 uppercase text-xs font-bold">{{
          date
        }}</span>
        <ul class="text-sm">
          <li>
            <ul>
              <li
                v-for="item in items"
                :key="item.hashedId"
                class="pl-2 border-l border-tiara-300 dark:border-tiara-500"
                :class="{
                  'border-l-2 border-tiara-500 dark:border-tiara-300 font-bold':
                    item.hashedId == $route.params.researchCompassId,
                }"
              >
                <div class="flex w-full justify-between">
                  <router-link
                    class="text-blueDianne dark:text-white hover:underline"
                    :to="`/public/${item.hashedId}/${item.viewKey}`"
                    @click="$emit('toggle-history-tray')"
                    >{{ item.title }}</router-link
                  >
                  <button
                    class="text-tiara-300 hover:text-puertoRico text-xs ml-2"
                    @click="toggleRemoveResearchCompassModal(item.hashedId)"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <regular-modal
                  :ref="`removeResearchCompass${item.hashedId}Modal`"
                  :showing="false"
                >
                  <template #header>
                    <h4 class="text-xl font-headline">
                      Remove Research Compass
                    </h4>
                  </template>
                  <template #body>
                    <div
                      class="w-full max-h-[calc(100vh-250px)] overflow-auto px-6 py-4"
                    >
                      <div class="relative w-full mb-3">
                        <p>
                          Are you sure you want to remove access to "{{
                            item.title
                          }}?".
                        </p>
                      </div>
                    </div>
                  </template>
                  <template #footer>
                    <div class="flex w-full justify-end items-center">
                      <div>
                        <button
                          class="modal-nonprimary-button"
                          type="submit"
                          @click="
                            toggleRemoveResearchCompassModal(item.hashedId)
                          "
                        >
                          <span>Cancel</span>
                        </button>
                        <button
                          class="modal-primary-button"
                          type="submit"
                          @click="
                            removeResearchCompassFromCookies(item.hashedId)
                          "
                        >
                          <span>Remove</span>
                        </button>
                      </div>
                    </div>
                  </template>
                </regular-modal>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="$route.params.researchCompassId" class="block text-center mt-5">
      <router-link
        class="text-blueDianne hover:underline"
        to="/"
        @click="$emit('toggle-history-tray')"
      >
        <button
          class="bg-blueDianne dark:bg-white px-3 py-2 text-white dark:text-blueDianne text-sm rounded-lg w-full"
        >
          Start a new chat
        </button>
      </router-link>
    </div>
    <p
      v-if="
        !$store.getters.person?.hashedId &&
        Object.keys(previousResearchCompassItemsFromCookiesByDate).length == 0
      "
      class="form-help"
    >
      Your Research Compass history will appear here. Ask a question to get
      started.
    </p>
  </div>
</template>

<script>
import * as utils from "../../utils";
import RegularModal from "../Modals/Regular.vue";

const { keysToCamel } = utils;

export default {
  components: {
    RegularModal,
  },
  props: {
    expireAnonymousDays: Number,
    usage: Object,
  },
  data() {
    return {
      previousResearchCompassItemsFromCookies: [],
      previousResearchCompassItemsFromDatabase: [],
      cookieIntervalId: null,
    };
  },
  computed: {
    previousResearchCompassItemsFromCookiesByDate() {
      const itemsByDate = {};
      const sorted = [...this.previousResearchCompassItemsFromCookies].sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
      );
      sorted.forEach((item) => {
        const dateKey = this.$dayjs(item.updatedAt).fromNow();
        if (!itemsByDate[dateKey]) {
          itemsByDate[dateKey] = [];
        }
        itemsByDate[dateKey].push(item);
      });
      return itemsByDate;
    },
    previousResearchCompassItemsFromDatabaseByDate() {
      const itemsByDate = {};
      const sorted = [...this.previousResearchCompassItemsFromDatabase].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );
      sorted.forEach((item) => {
        const dateKey = this.$dayjs.utc(item.createdAt).local().fromNow();
        if (!itemsByDate[dateKey]) {
          itemsByDate[dateKey] = [];
        }
        itemsByDate[dateKey].push(item);
      });
      return itemsByDate;
    },
    remainingChatText() {
      return `You have ${this.usage.remainingChats} chat${
        this.usage.remainingChats !== 1 ? "s" : ""
      } remaining ${
        this.usage.interval === "WEEK" || this.usage.interval === "MONTH"
          ? `this ${this.usage.interval.toLowerCase()}`
          : "in this 24-hour period"
      }. ${
        this.usage.remainingChats === 0 && this.usage.moreAvailableAt
          ? `More available ${this.$dayjs(
              this.usage.moreAvailableAt,
            ).fromNow()}.`
          : ""
      } ${
        this.$store.getters.person
          ? "Upgrade to get more chats."
          : "Sign up to get more chats."
      }`;
    },
  },
  watch: {
    previousResearchCompassItemsFromDatabaseByDate(newValue) {
      if (
        Object.keys(this.previousResearchCompassItemsFromCookiesByDate).length >
          0 ||
        Object.keys(newValue).length > 0
      ) {
        this.$emit("setHasHistory", true);
      } else {
        this.$emit("setHasHistory", false);
      }
    },
    previousResearchCompassItemsFromCookiesByDate(newValue) {
      if (
        Object.keys(newValue).length > 0 ||
        Object.keys(this.previousResearchCompassItemsFromDatabaseByDate)
          .length > 0
      ) {
        this.$emit("setHasHistory", true);
      } else {
        this.$emit("setHasHistory", false);
      }
    },
  },
  mounted() {
    if (this.$store.getters.person?.hashedId) {
      this.getOwnResearchCompassItems();
    }
    this.updatePreviousResearchCompassItemsFromCookies();
    this.cookieIntervalId = setInterval(
      this.updatePreviousResearchCompassItemsFromCookies,
      10000,
    );
    if (
      Object.keys(this.previousResearchCompassItemsFromCookiesByDate).length >
        0 ||
      Object.keys(this.previousResearchCompassItemsFromDatabaseByDate).length >
        0
    ) {
      this.$emit("setHasHistory", true);
    }
  },
  beforeUnmount() {
    clearInterval(this.cookieIntervalId);
  },
  methods: {
    toggleRemoveResearchCompassModal(hashedId) {
      this.$refs[`removeResearchCompass${hashedId}Modal`][0].toggleModal();
    },
    getOwnResearchCompassItems() {
      this.$api.axios.get("/research-compass/").then((resp) => {
        const data = keysToCamel(resp.data);
        this.previousResearchCompassItemsFromDatabase = data.results;
      });
    },
    expireAnonymousResearchCompassItems() {
      let existingItems = this.$cookies.get("researchCompassItems") || [];
      const cutoffDate = this.$dayjs().subtract(
        this.expireAnonymousDays + 1,
        "day",
      );
      existingItems = existingItems.filter((item) =>
        this.$dayjs(item.createdAt).isAfter(cutoffDate),
      );
      this.$cookies.set("researchCompassItems", JSON.stringify(existingItems), {
        path: "/",
        maxAge: 60 * 60 * 24 * 365,
      });
    },
    updatePreviousResearchCompassItemsFromCookies() {
      this.expireAnonymousResearchCompassItems();
      this.previousResearchCompassItemsFromCookies =
        this.$cookies.get("researchCompassItems") || [];
    },
    removeResearchCompassFromCookies(hashedId) {
      let existingItems = this.$cookies.get("researchCompassItems") || [];
      existingItems = existingItems.filter(
        (item) => item.hashedId !== hashedId,
      );
      this.$cookies.set("researchCompassItems", JSON.stringify(existingItems), {
        path: "/",
        maxAge: 60 * 60 * 24 * 365,
      });
      this.updatePreviousResearchCompassItemsFromCookies();
      if (hashedId === this.$route.params.researchCompassId) {
        this.$router.push({ name: "Home" });
      }
    },
    deleteResearchCompass(hashedId) {
      this.$api.axios.delete(`/research-compass/${hashedId}/`).then(() => {
        this.getOwnResearchCompassItems();
        if (hashedId === this.$route.params.researchCompassId) {
          this.$router.push({ name: "Home" });
        }
      });
    },
  },
};
</script>
